<div class="layout-auto-1">
  <div></div>
  <div class="content md3-surface">
    <div class="layout-list-quickfilter md3-card-on-surface">
      <exg-search-bar (Search)="companyTable.search($event)" [placeholder]="getRessource('companyListSearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i class="search-action fal fa-sync" (click)="loadCompanyData()"></i>
          <i class="search-action fal fa-filter" (click)="togglePopupMenu($event, VCcompanyTableFilterPopup)"></i>
          <exg-popup #VCcompanyTableFilterPopup [closeAlways]="false" width="360">
            <app-exg-filter #VCcompanyTableFilterControl [MetaInfo]="companyTable.MetaInfo"
                            [uiFilter]="companyTable.uiFilter" [uiSort]="companyTable.uiSort" [showFilter]="true"
                            (onActivateFilter)="closePopupMenuAndReload();"></app-exg-filter>
          </exg-popup>
          <i class="search-action fal fa-sort-alt" (click)="togglePopupMenu($event, VCcompanyTableSortPopup)"></i>
          <exg-popup #VCcompanyTableSortPopup [closeAlways]="false" width="360">
            <app-exg-filter [MetaInfo]="companyTable.MetaInfo" [uiFilter]="companyTable.uiFilter"
                            [uiSort]="companyTable.uiSort" [showSort]="true"
                            (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>
          </exg-popup>
          <i class="search-action fal fa-binoculars" (click)="togglePopupMenu($event, VCcompanyTableSearchPopup)"></i>
          <exg-popup #VCcompanyTableSearchPopup [closeAlways]="false" width="360">
            <app-exg-filter [MetaInfo]="companyTable.MetaInfo" [uiFilter]="companyTable.uiFilter"
                            [uiSort]="companyTable.uiSort" [showSearch]="true"
                            (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter>
          </exg-popup>
        </ng-template>
      </exg-search-bar>
      <div class="content app-companyTable">
        <exg-data-table #VCcompanyTable
                        (RowChange)="companyTable.selectionChanged($event)"
                        [allowSingleSelection]="true"
                        [displayState]="companyTable.state"
                        [rowSource]="companyTable.data"
                        containerClass="grid cols-19"
                        [selectKey]="companyTable.selectKey">
          <ng-template #headerTemplate>
            <div class="span-3 typo-small">
              {{enumSvc.getFieldCaption('Company',"compName")}}
            </div>
            <div class="typo-small span-4">
              {{enumSvc.getFieldCaption('Company', "Adress")}}
            </div>
            <div class="span-2 typo-small">
              {{enumSvc.getFieldCaption('Company', "compContactMail")}}
              <br>{{enumSvc.getFieldCaption('Company', "compContactNumber")}}
            </div>
            <div class="span-2 typo-small">
              {{enumSvc.getFieldCaption('Company', "compWebsite")}}
            </div>
            <div class="span-2 typo-small">
              {{enumSvc.getFieldCaption('Company', "compTaxID")}}
              <br>{{enumSvc.getFieldCaption('Company', "compSalesTaxID")}}
            </div>
            <div class="span-2 typo-small">
              <br>{{enumSvc.getFieldCaption('Company', "compRegisterNo")}}
            </div>
            <div class="span-2 typo-small">
              {{enumSvc.getFieldCaption('All', '%CRU')}}
              <br>{{enumSvc.getFieldCaption('All', '%CRD')}}
            </div>
            <div class="span-2 typo-small">
              {{enumSvc.getFieldCaption('All', '%LCU')}}
              <br>{{enumSvc.getFieldCaption('All', '%LCD')}}
            </div>
          </ng-template>
          <ng-template #rowTemplate let-row>
            <div class="span-3">
              <p>{{row.compName}}</p>
            </div>
            <div class="typo-small span-4">
              <p>{{getAdresslines(row)}}</p>
              <p>{{isNumberString(row.compCountry) ? enumSvc.getEnumerationTextA('Country', row.compCountry) : row.compCountry }}{{row.compZip}}{{row.compLocation}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compContactMail}}</p>
              <p>{{row.compContactNumber}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compWebsite}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compTaxID}}</p>
              <p>{{row.compSalesTaxID}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compRegisterNo}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compCRU}}</p>
              <p>{{row.compCRD | excDate: getRessource('DateTimeFormat')}}</p>
            </div>
            <div class="span-2 typo-small">
              <p>{{row.compLCU}};</p>
              <p>{{row.compLCD | excDate: getRessource('DateTimeFormat')}}</p>
            </div>
          </ng-template>
        </exg-data-table>
        <div class="content drawer-container right app-table-drawer">
          <div [ngClass]="{'visible': rightDrawerVisible }"
               class="drawer-content width-500 app-layout-frame-drawer md3-card-on-surface app-space-right_0">
            <div class="content">
              <ng-container *ngIf="tableLoading || tableEmpty">
                <div *ngIf="tableEmpty && !tableLoading" class="splash empty">
                  <p>{{getRessource('zeroRows')}}</p>
                </div>
                <div *ngIf="tableLoading" class="splash loading">
                  <div class="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </ng-container>
                <app-exg-tab-v2 #VCrightTabControl (tabchange)="rightTabs_tabChange($event)"
                         [header]="rightTabs" [hidden]="tableLoading || tableEmpty">
                  <ng-template #pages>
                    <!-- 1 - Details-->
                    <div class="content">
                      <div class="grid-1-auto">
                        <h2>
                          <i [class]="getRessource('Icon')"></i>
                          {{getGlobal('Company')}}: {{companyTableDrawer.company?.compName}}
                        </h2>
                        <div>
                        </div>
                      </div>

                      <div class="typo-container-s-s-q">
                        <span class="width-200"></span>
                        <span></span>
                        <q></q>
                        <span>{{enumSvc.getFieldCaption('Company', 'compAdressline1')}}</span>
                        <span>{{companyTableDrawer.company?.compAdressline1}}</span>
                        <q></q>
                        <span>{{enumSvc.getFieldCaption('Company', 'compAdressline2')}}</span>
                        <span>{{companyTableDrawer.company?.compAdressline2}}</span>
                        <q></q>
                        <ng-container *ngIf="(companyTableDrawer.company?.compAdressline3 + companyTableDrawer.company?.compAdressline4).length > 1">
                          <span>{{enumSvc.getFieldCaption('Company', 'compAdressline3')}}</span>
                          <span>{{companyTableDrawer.company?.compAdressline3}}</span>
                          <q></q>
                          <span>{{enumSvc.getFieldCaption('Company', 'compAdressline4')}}</span>
                          <span>{{companyTableDrawer.company?.compAdressline4}}</span>
                          <q></q>
                        </ng-container>
                        <ng-container *ngIf="(companyTableDrawer.company?.compCountry + companyTableDrawer.company?.compZip + companyTableDrawer.company?.compLocation).length > 1">
                          <span>{{enumSvc.getFieldCaption('Company', 'compZip')}} - {{enumSvc.getFieldCaption('Company', 'compLocation')}}</span>
                          <span>{{companyTableDrawer.company?.compCountry }} {{ companyTableDrawer.company?.compZip }} {{ companyTableDrawer.company?.compLocation}}</span>
                          <q></q>
                        </ng-container>
                        <span class="width-200"></span>
                        <span></span>
                        <q></q>
                      </div>
                      <div class="search-filter-seperator"></div>
                      <div class="typo-container-s-s-q">
                        <span class="width-200"></span>
                        <span></span>
                        <q></q>
                        <span>{{enumSvc.getFieldCaption('Company', 'compTaxID')}}</span>
                        <span>{{companyTableDrawer.company?.compTaxID}}</span>
                        <q></q>
                        <span>{{enumSvc.getFieldCaption('Company', 'compSalesTaxID')}}</span>
                        <span>{{companyTableDrawer.company?.compSalesTaxID}}</span>
                        <q></q>
                        <span>{{enumSvc.getFieldCaption('Company', 'compRegisterNo')}}</span>
                        <span>{{companyTableDrawer.company?.compRegisterNo}}</span>
                        <q></q>
                      </div>
                      <div class="search-filter-seperator"></div>
                      <ng-container *ngIf="excSecurity.isFeatured('DEVELOPMENT')">
                        <h2>Übersicht Positionen</h2>
                        <app-company-chart>
                        </app-company-chart>
                        <h2>Positions Beträge</h2>
                        <app-company-chart-types>
                        </app-company-chart-types>
                      </ng-container>
                    </div>
                    <!-- 1 - Details-->
                    <div class="content app-subarea">
                      <ng-container *ngIf="companyTableDrawer.state !== 0">
                        <div *ngIf="companyTableDrawer.state === 2" class="splash empty">
                          <p>{{getRessource('zeroRows')}}</p>
                        </div>
                        <div *ngIf="companyTableDrawer.state === 1" class="splash loading">
                          <div class="spinner">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      </ng-container>
                      <exg-data-table #VCcompanyreceiptTable
                                      (RowChange)="companyTableDrawer.selectionChanged($event)"
                                      [allowSingleSelection]="true"
                                      [displayState]="companyTableDrawer.state"
                                      [rowSource]="companyTableDrawer.receipts"
                                      [selectKey]="companyTableDrawer.selectKey"
                                      containerClass="grid cols-10">
                        <ng-template #headerTemplate>
                          <div class="span-2 typo-small">
                            {{enumSvc.getFieldCaption("Auftrag", "Auftrag")}} <!-- Order -->
                            <br>{{enumSvc.getFieldCaption("Auftrag", "auAnsprechpartner")}}<!-- Order -->
                          </div>
                          <div class="span-2 typo-small">
                            {{enumSvc.getFieldCaption("Vorgang", "vorgNr")}}
                            <br>{{enumSvc.getFieldCaption("Vorgang", "vorgBearbeiter")}} <!-- Vorgang Task-->
                          </div>
                          <div class="span-2 typo-small">
                            {{enumSvc.getFieldCaption("Receipt", "rcpt_enmIdent_ReceiptStatus")}}
                            <br>{{enumSvc.getFieldCaption("Receipt", "rcpt_enmIdent_ReceiptType")}}
                          </div>
                          <div class="span-2 typo-small">
                            {{enumSvc.getFieldCaption("Receipt", "rcptNumber")}}
                            <br>{{enumSvc.getFieldCaption("Receipt", "rcptDate")}}
                          </div>
                          <div class="span-2 typo-small">
                            <br>{{enumSvc.getFieldCaption("Receipt", "rcptDesc")}}
                          </div>
                        </ng-template>
                        <ng-container *ngIf="!companyTableDrawer.isLoading">
                          <ng-template #rowTemplate let-row>

                            <div class="span-2 typo-small">
                              <p>{{row.auNr}}</p>
                              <p>{{row.auAnsprechpartner}}</p>
                            </div>
                            <div class="span-2 typo-small">
                              <p>{{row.vorgNr}}</p>
                              <p>{{row.vorgBearbeiter}}</p>
                            </div>
                            <div [class.deleted]="row.rcptDEL" class="span-2 typo-small">
                              <p>{{enumSvc.getEnumerationText('ReceiptStatus', row.rcpt_enmIdent_ReceiptStatus)}}</p>
                              <p>{{enumSvc.getEnumerationText('ReceiptType', row.rcpt_enmIdent_ReceiptType)}}</p>
                            </div>
                            <div class="span-2 typo-small">
                              <p>{{row.rcptNumber}}</p>
                              <p>
                                <ng-container *ngIf="row.rcptDate > 0">
                                  {{row.rcptDate | excDate: getRessource('DateTimeFormat')}}
                                </ng-container>
                              </p>
                            </div>
                            <div class="span-2 typo-small">
                              {{row.rcptDesc}}
                            </div>
                          </ng-template>
                        </ng-container>
                      </exg-data-table>

                    </div>
                  </ng-template>
                </app-exg-tab-v2>
            </div>
          </div>
        </div>
      </div>
      <div class="app-drawer">
        <i (click)="toggleRightDrawer()"
           [class.selected]="rightDrawerVisible"
           [class.disabled]="VCcompanyTable.selectedRow === -1"
           class="search-filter-action fal fa-info">
        </i>
        <i class="app-no-border"></i>
        <ng-container *ngIf="rightDrawerVisible && VCrightTabControl.selectedtab === 1">
          <i (click)="openCheckView();" [tooltip]="getRessource('openCheckview')" flow="left"
             class="search-filter-action fal fa-file-search"
             [class.disabled]="tableEmpty || companyTableDrawer.receipts.length === 0"></i>
          <i (click)="openWorkspace();" [tooltip]="getRessource('openWorkspace')" flow="left"
             class="search-filter-action fal fa-clipboard"
             [class.disabled]="tableEmpty || companyTableDrawer.receipts.length === 0"></i>
          <i class="search-filter-seperator"></i>
        </ng-container>
      </div>
      <exg-pager class="span-layout" *ngIf="companyTable.state === 0"
                 (PageChange)="companyTable.pageChanged($event)"
                 [pagingSource]="companyTable.paging">
        <ng-template #leftTemplate>
        </ng-template>
        <ng-template #rightTemplate>
          <span *ngIf="companyTable.isFiltered()">(gefiltert)</span>
        </ng-template>
      </exg-pager>
    </div>
  </div>
</div>
